import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNetwork } from '../contexts/NetworkContext'

/** Translates a stat label the way the stats are worded on this network. */
export type StatLabel = (labelKey: string, options?: Record<string, unknown>) => string

/**
 * A marketplace trades in bids, so its stats are named after them: requests
 * are bid requests, what the ad server serves is a bid response, and only what
 * rendered counts as an impression. Those wordings live under the `marketplace`
 * i18n context (`stats.rendered_marketplace`), and any label without one reads
 * as it does everywhere else.
 */
export function useStatLabel(): StatLabel {
  const { t } = useTranslation()
  const { currentNetwork } = useNetwork()
  const context = currentNetwork?.marketplacePlatform ? 'marketplace' : undefined
  return useCallback(
    (labelKey, options) => t(labelKey, { ...options, context }) as string,
    [t, context]
  )
}
